import { formatDate } from "@/lib/utils";
import { ExamLiveDtoClient } from "@/api/live-exam/dto/exam-live.dto";
import { Badge } from "@/components/atoms/Badge";
import ExamStatusBadge from "@/components/molecules/Badges/ExamStatusBadge";
import ExamTypeBadge from "@/components/molecules/Badges/ExamTypeBadge";
import PercentageProgress from "@/components/molecules/Progress/PercentageProgress";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<ExamLiveDtoClient>();

export const columns = [
  columnHelper.accessor("number", {
    id: "number",
    header: "N° Session",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("date", {
    id: "date",
    header: "Date exam.",
    cell: (info) => formatDate(info.getValue()),
  }),
  columnHelper.accessor("type", {
    id: "type",
    header: "Type",
    cell: (info) => <ExamTypeBadge examType={info.getValue()} />,
  }),
  columnHelper.accessor(
    ({ status, registeringEndDate }) => ({ status, registeringEndDate }),
    {
      id: "status",
      header: "Statut",
      cell: (info) => {
        const { registeringEndDate, status } = info.getValue();
        return (
          <ExamStatusBadge
            status={status}
            registeringEndDate={new Date(registeringEndDate)}
          />
        );
      },
    },
  ),
  columnHelper.accessor("registeredCount", {
    id: "registered",
    header: "Inscrits",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("absentCount", {
    id: "missingCandidatesCount",
    header: "Nombre d'abs",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("reportedCandidatesCount", {
    id: "reportedCandidatesCount",
    header: "Nombre reports",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("subjectsCount", {
    id: "subjectCount",
    header: "Nombre de sujets",
    cell: (info) => <Badge variant="white">{info.getValue()}</Badge>,
  }),
  columnHelper.accessor("successRate", {
    id: "successPercentage",
    header: "% d'admis",
    cell: (info) => <PercentageProgress rate={info.getValue()} />,
  }),
];
